import React,{useState} from "react";
import BackButton from "../../../../../components/common/backbutton/BackButton";
import NewWard from "./NewWard";
import OldWard from "./OldWard";

const WardRenewal = () => {
  const [turnOn, setTurnOn] = useState(true)  

  return (
    <div className="md:px-10 px-3 lg:!px-14">
        <p className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-2xl">
          Ward Renewals
        </p>
        <div className="flex justify-between font-Laila">
          <div className=" flex space-x-6 text-primary-red text-base font-bold sm:text-lg">
            <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full  p-1 text-white">
              <label htmlFor="old">पहिले नै हामीसंग आवद्ध भएको कम्पनी</label>
              <input type="radio" name="radio-btn" id="old" 
              onChange={()=> setTurnOn(true)}
              />
            </div>
            <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
              <label htmlFor="new">नयाँ कम्पनी </label>
              <input type="radio" name="radio-btn" id="new" 
              onChange={()=> setTurnOn(false)}
              />
            </div>
          </div>
          <div className="text-primary-red flex items-center">
            Firm No.
            <p className=" text-primary-blue"> 1234</p>
          </div>
        </div>
        <div className="flex justify-between my-4">
          <p className="text-primary-blue  text-lg underline">
            1. Business Name & Other Details
          </p>
        </div>

        {/* company name and other details */}
        {/* <div className="flex-col flex md:flex-row flex-wrap">
          <div className="flex flex-wrap border-2 border-primary-blue">
            <p className="text-primary-red flex-nowrap items-center shrink-0 flex font-bold text-base">
              कम्पनी वा ब्यवसायको नाम:
            </p>
            <input className="py-2" type="search" placeholder="Search" />
          </div>
          <div className="flex flex-wrap w-fit border-2 border-primary-blue">
            <p className="text-primary-red flex items-center font-bold text-base">
              ठेगाना :
            </p>
            <input className=" " type="" placeholder="" />
          </div>
          <div className="flex flex-wrap w-fit border-2 border-primary-blue">
            <p className="text-primary-red flex items-center font-bold text-base">
              स. ब्यक्तिको नाम :
            </p>
            <input className=" " type="text" placeholder="" />
          </div>
          <div className="flex flex-wrap w-fit border-2 border-primary-blue">
            <p className="text-primary-red flex items-center font-bold text-base">
              सम्पर्क नं. :
            </p>
            <input className=" " type="text" placeholder="" />
          </div>
        </div> */}
       
       {
        turnOn ? <OldWard/>: <NewWard/>
       }


    </div>
  );
};

export default WardRenewal;
